import { loadData } from "@/models/Types";
import { Event } from "@/models/Types/Event/Event";

export const dataEvents: Promise<Event[]> = loadData("events");
